<template>
  <div class="grid-view">
    <div class="main-content">
      <div class="section grid-wrapper">
        <cargo-ag-grid
          :config-module="configModule"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
        />
      </div>
    </div>
  </div>
</template>

<script>
import URL from '@/api/urlTranslator'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

export default {
  name: 'QuotationClientDataGrid',
  components: {},
  props: {
    configModule: { type: String, default: '227100' },
    gridOptions: { type: Object, default: () => {} },
    rowData: { type: Array, default: () => [] }
  },
  data() {
    return {
      URL,
      showDetail: false,
      fullscreenLoading: false,
      gridParams: {},
      gridApi: null,
      columnDefs: [
        { headerName: this.$t('Pricing.ClientName'), field: 'name', colId: 'name', width: 200, flex: 1
        },
        {
          headerName: this.$t('Pricing.Contact'), field: 'contact', colId: 'contact', width: 200, flex: 1
        },
        {
          headerName: this.$t('Pricing.Phone'), field: 'phone', colId: 'phone', width: 200, flex: 1
        },
        {
          headerName: this.$t('Pricing.Fax'), field: 'fax', colId: 'fax', width: 200, flex: 1
        },
        {
          headerName: this.$t('Pricing.Email'), field: 'email', colId: 'email', width: 200, flex: 1
        },
        {
          headerName: this.$t('Pricing.Owner'), field: 'ownerId', colId: 'ownerId', width: 200, flex: 1,
          valueFormatter: (params) => {
            if (params.value === -100) {
              return this.$t('Price.ExternalUser')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          tooltipValueGetter: (params) => {
            return ColumnUtils.userToolTipLabel(params.value)
          }
        },
        {
          headerName: this.$t('Pricing.CreatedBy'), field: 'createdBy', colId: 'createdBy', width: 200, flex: 1,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          tooltipValueGetter: (params) => {
            return ColumnUtils.userToolTipLabel(params.value)
          }
        },
        { headerName: this.$t('Pricing.CreatedDate'), field: 'dateCreated', colId: 'dateCreated', width: 200, flex: 1,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Pricing.ModifiedBy'), field: 'modifiedBy', colId: 'modifiedBy', width: 200, flex: 1,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          tooltipValueGetter: (params) => {
            return ColumnUtils.userToolTipLabel(params.value)
          }
        },
        { headerName: this.$t('Pricing.ModifiedDate'), field: 'dateModified', colId: 'dateModified', width: 200, flex: 1,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Pricing.Remarks'), field: 'remarks', colId: 'remarks', width: 200, flex: 1
        }
      ]
    }
  }
}
</script>
<style lang="scss">
</style>

